import * as ReactCollapse from 'react-collapse';
import { Box } from '@bridebook/ui';
import componentStyles from './collapse.style';
import { FC, PropsWithChildren } from 'react';

interface IProps extends PropsWithChildren {
  /**
   * Indicates if the content is always mounted in the DOM tree (SEO).
   * @default true
   */
  alwaysMounted?: boolean;
  /**
   * Indicates if the content should be animated.
   * @default true
   */
  withAnimation?: boolean;
  /* Indicates if the content is open */
  isOpen: boolean;
}

/**
 * Collapse component: a wrapper for ReactCollapse.Collapse (or ReactCollapse.UnmountClosed).
 * It allows to animate the opening and closing of the content.
 */
export const Collapse: FC<IProps> = ({
  alwaysMounted = true,
  withAnimation = true,
  isOpen,
  children,
}) => {
  const styles = componentStyles({ withAnimation });

  const ReactCollapseComponent = alwaysMounted
    ? ReactCollapse.Collapse
    : ReactCollapse.UnmountClosed;

  return (
    <Box style={styles.root}>
      <ReactCollapseComponent isOpened={isOpen}>{children}</ReactCollapseComponent>
    </Box>
  );
};
